import AdminAddPasein from "../../components/AdminOdontogramRestorativeMaterial/AdminOdontogramRestorativeMaterialAdd";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminAddPasein/>
    </div>
  );
}
